// extracted by mini-css-extract-plugin
export var continueWithSelectionButton = "DocumentCamera-module--continueWithSelectionButton--EMbwU";
export var selected = "DocumentCamera-module--selected--3hyoY";
export var selectedIcon = "DocumentCamera-module--selectedIcon--2a6Bj";
export var selectedImageList = "DocumentCamera-module--selectedImageList--7VvHk";